import { render } from "./page-header-component.vue?vue&type=template&id=804caef0&scoped=true"
import script from "./page-header-component.vue?vue&type=script&lang=js"
export * from "./page-header-component.vue?vue&type=script&lang=js"

import "./page-header-component.vue?vue&type=style&index=0&id=804caef0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-804caef0"]])

export default __exports__